import React from "react";

export const useHiddenItems = (initialHiddenItems: Set<string> = new Set()) => {
    const [hiddenItems, setHiddenItems] = React.useState(initialHiddenItems);

    const toggleItem = (itemName: string) => {
        setHiddenItems((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(itemName)) {
                newSet.delete(itemName);
            } else {
                newSet.add(itemName);
            }
            return newSet;
        });
    };

    return {
        hiddenItems,
        toggleItem,
        setHiddenItems,
    };
};
